import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef as MatDialogRef, MAT_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';

@Component({
    selector: 'app-account-update-dialog',
    templateUrl: './account-update-dialog.component.html',
    styleUrls: ['./account-update-dialog.component.scss'],
    standalone: false
})
export class AccountUpdateDialogComponent implements OnInit {

// Shared component to display account update warning
constructor(@Inject(MAT_DIALOG_DATA) public data: { userId: string },public dialogRef: MatDialogRef<AccountUpdateDialogComponent>, private router: Router) { 
  dialogRef.disableClose = true;
}

ngOnInit(): void {

}

public updateAccount() {
  this.dialogRef.close();
  this.router.navigate(['/user-profile', this.data.userId, 0]);
}

}


